document.addEventListener('click', function (event) {
  var btn = event.target.closest('[data-close-facets]');
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();

  var drawer = btn.closest('facets-drawer');

  if (!drawer) {
    var controlledId = btn.getAttribute('aria-controls');
    if (controlledId) drawer = document.getElementById(controlledId);
  }

  if (!drawer) {
    drawer = document.getElementById('facets-drawer');
  }

  if (drawer) {
    if (typeof drawer.hide === 'function') {
      drawer.hide();
    } else {
      drawer.removeAttribute('open');
      drawer.setAttribute('hidden', '');
    }
  }
});